import { useState, useCallback } from 'react'

const COOKIE_KEY = 'cookie-consent'

export function useCookieConsent() {
  const [accepted, setAccepted] = useState(() => {
    return localStorage.getItem(COOKIE_KEY) === 'true'
  })

  const accept = useCallback(() => {
    localStorage.setItem(COOKIE_KEY, 'true')
    setAccepted(true)
  }, [])

  return { accepted, accept }
}
